import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, } from '@angular/core';
import { HeaderState } from 'src/app/models/header/HeaderState';
import { TreeAction } from 'src/app/models/tree/TreeAction';
import { TreeLevels } from 'src/app/models/tree/TreeLevels';
import { TreeService } from 'src/app/services/Tree.service';
import { activateTreeItem, createTree } from '../../helpers/Index';
import Swal from 'sweetalert2';
import { TreeNode } from 'src/app/models/tree/TreeNode';
import { DataService } from 'src/app/services/Data.service';
import { take } from 'rxjs/operators';
declare var jQuery: any;

@Component({
  selector: 'app-tree-load',
  templateUrl: './tree.load.component.html',
})
export class TreeLoadComponent implements OnInit  {
  title : string = 'Tree-Load';
  
  //Tree values
  @Output() canActivateActionsMenu = new EventEmitter<TreeAction>();
  @Input() userId: number = 0;
  @Input() module: string = '';
  @Input() department: string = '';
  @Input() rol: string = '';
  onlyMySimulations: boolean;

  searchText: string = null;
  @Input() set search(value: string) { this.searchText = value; }
    
  tree: TreeLevels;
  selected: TreeAction = { id: 0, text: '', level: '', activate: false, action: '', path: '', parents: '', userId: 0, notes: '', visibility: '' };
  nameUser: string;
  userNode: TreeNode;
  constructor(public treeService: TreeService,public dataService: DataService) {}
  ngOnInit(): void {
    this.dataService.currentUserIdSource.subscribe(userId => (this.userId= userId));
    this.dataService.currentModuloSource.subscribe(module => (this.module= module));
    this.dataService.currentDepartmentSource.subscribe(dpto => (this.department= dpto));
    this.dataService.currentNameSurnameSource.subscribe(nameSurname => (this.nameUser= nameSurname));
    this.dataService.currentRolSource.pipe().subscribe(rol => {
        if(rol.some(x => x == "ADMIN")){
          this.rol = 'ADMIN';
        }
        else if(rol.some(x => x == "SUPER_USER")) {
          this.rol = 'SUPER_USER';
        } else if(rol.some(x => x == "USER")) {
          this.rol = 'USER';
        }
    });
    this.treeService.observableOnlyMySimulations.subscribe(onlyMySimulationsValue => {
      if(this.onlyMySimulations != undefined)
        this.getTree(this.userId, this.module, onlyMySimulationsValue);

      this.onlyMySimulations = onlyMySimulationsValue;
    });
  }

  getTree(userId: number, module:string, onlyMySimulations: boolean) {
    this.treeService.getNodeTreeByUserIdVisibility(this.userId, this.department, this.rol, this.module, onlyMySimulations).subscribe(levels => {
      if (levels.status.success){
        this.tree = createTree(levels.data, true);
      }
    },
      err  => {
        Swal.fire({
          title: 'An error occurred',
          icon: 'error',
          confirmButtonColor: '#009',
          cancelButtonColor: '#aaa',
        });
      });
  }

  canActivateActions(selected: TreeAction){
    selected.userId = this.userId;
    selected.action = HeaderState.load;
    this.selected = selected;
    this.selected = activateTreeItem(this.tree, HeaderState.load, selected);
    this.canActivateActionsMenu.emit(selected);
  }

  // ValidaIngresoUsuario logic removed
}
